import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-lg font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ndd-400 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-ndd-700 text-white hover:bg-ndd-600 active:bg-ndd-500',
        destructive: 'bg-red-700 text-white hover:bg-red-600',
        outline: 'border border-ndd-600 bg-transparent text-ndd-300 hover:bg-ndd-900',
        ghost: 'text-ndd-300 hover:bg-ndd-900',
        secondary: 'bg-ndd-900 text-white hover:bg-ndd-800',
      },
      size: {
        default: 'h-12 px-4 py-2',
        sm: 'h-9 px-3 text-sm',
        lg: 'h-14 px-6 text-lg',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
    );
  }
);
Button.displayName = 'Button';

export { buttonVariants };
